import logo from "../assets/logo.png";
import { HashLoader } from 'react-spinners';
const SpinnerComponent = () => {

  return (
    <div className="fallback-spinner h-100">
      <div className="loading">
          <HashLoader color="#D9D9D9"/>
      </div>
    </div>
  );
};

export { SpinnerComponent };
